import type { CustomerResponse } from '@troia-v3/types';

/**
 * Badge de tipo (PF/PJ) — variante neutra, sem relação com status.
 * Helper compartilhado do módulo (extraído do antigo `CustomerCard`, aposentado
 * na padronização de UI 2026-07 — grid usa `CustomerGridCard`).
 */
export function getCustomerTypeBadge(type: CustomerResponse['type']): { label: string; icon: 'user' | 'briefcase' } {
  return type === 'PF' ? { label: 'PF', icon: 'user' } : { label: 'PJ', icon: 'briefcase' };
}
